// extracted by mini-css-extract-plugin
module.exports = {"bg":"didYouKnow-module--bg--pqaH-","small":"didYouKnow-module--small--3WHgZ","separator":"didYouKnow-module--separator--eyRYb"};